import { generateId } from "@cayuse/shared-react.utils.helpers";

import { fetchForm, notifyError } from "utils";
import store, { dispatch } from "store/store";
import { form as constants } from "store/constants";
import { actionLoaderFactory } from "store/factories/fetchable";
import { NEW_RULE_ID, IS_DEV } from "globals/constants";
import { api } from "services";


const factory = actionLoaderFactory(constants, constants.FORM);

export const setRules = payload => dispatch({ type: constants.SET_RULES, payload });

export const setEffortFormat = payload => dispatch({ type: constants.SET_EFFORT_FORMAT, payload });

export const resetForm = () => dispatch({ type: constants.RESET });

export const getForm = async formModelId => {
	return factory.createLoaderAction(
		() => fetchForm(formModelId),
		[
			(response) => {
				factory.setData(response);
			},
			(error, { getState }) => {
				const dictionary = getState().dictionary.common;
				const message = IS_DEV ? error.message : dictionary.form.failGetFormDetails;

				notifyError(message, error);
				factory.setError(message);
			},
		],
	);
};

export const updateFormWithLastPublishedFormElements = elements => {
	factory.setData({
		lastPublishedFormElements: elements,
	});
};

export const updateRules = async (formId, rules) => {
	try {
		await api.form.updateRules(formId.replace("FORM_MODEL-", ""), rules);

		const updatedRules = rules.map(rule => rule.id === NEW_RULE_ID ? { ...rule, id: generateId("rule") } : rule);

		setRules(updatedRules);

	} catch (error) {
		const dictionary = store.getState().dictionary.common;
		const message = IS_DEV ? error.message : dictionary.form.ruleCantBeSaved;

		notifyError(message, error);
	}
};
